var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-menu"},[_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:_vm.activeIndex === index ? 'active list-item':'list-item',on:{"click":function($event){return _vm.toPage(item, index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }